import { useDeviceType } from '../../../hooks/useDeviceType';
import { Grid, GridItem, GridRow } from '../../Grid';
import React, { ReactNode } from 'react';
import { IRatingBanner } from '../index';
import { WrapperComponent } from './WrapperComponent';

export interface IContainer extends Pick<IRatingBanner, 'ratingMsg'> {
  children: ReactNode;
}

export const Container = ({ children, ratingMsg }: IContainer) => {
  const { isMobile } = useDeviceType();

  return (
    <div className={!isMobile ? 'overflow-hidden md:pt-20 md:pb-20' : ''}>
      <WrapperComponent ratingMsg={ratingMsg}>
        <Grid skipPaddingOnMobile={isMobile}>
          <GridRow columns={16}>
            <GridItem colStart={isMobile ? 0 : 3} colSpan={isMobile ? 16 : 12}>
              {children}
            </GridItem>
          </GridRow>
        </Grid>
      </WrapperComponent>
    </div>
  );
};
